import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Container, Section, Kicker, Card, Reveal } from '../components/ui/Primitives';
import { RESOURCES } from '../data/resources';
export function Resources() {
  return <>
      <section className="surface-dark" data-id="element-1300" data-mp="t3a1zk9nv62r">
        <Container className="py-14 sm:py-20" data-id="element-1301" data-mp="t4bqorjlnr2y">
          <Kicker data-id="element-1302" data-mp="t0w83eqpvzws">Resources</Kicker>
          <h1 className="mt-4 max-w-3xl font-display text-[34px] leading-tight text-white sm:text-[46px]" data-id="element-1303" data-mp="1gsbcre5yutb7">
            The material we use in client work, free to download
          </h1>
          <p className="mt-6 max-w-2xl text-[17px] text-white/72" data-id="element-1304" data-mp="16ux8se18bwzs">
            Templates, assessments and reports written for practitioners. We ask for an email so we can send the
            file and, if you want it, the fortnightly brief.
          </p>
        </Container>
      </section>

      <Section data-id="element-1305" data-mp="el6q1vaduyx">
        <div className="grid gap-8 lg:grid-cols-3" data-id="element-1306" data-mp="f4it1y99p51">
          {RESOURCES.map((resource, index) => <Reveal key={resource.slug} delay={index * 0.06} data-id="element-1307" data-mp="21qa0rubc5hsg" data-mpi={index}>
              <Card className="flex h-full flex-col" data-id="element-1308" data-mp="21sv4kov727su">
                <img src={resource.cover} alt={resource.coverAlt} loading="lazy" className="aspect-[4/3] w-full rounded-sm object-cover" data-id="element-1309" data-mp="1xqrspz4m5171" />
                <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-1310" data-mp="26otre80vjhr5">
                  {resource.format} · {resource.pages} pages
                </p>
                <h2 className="mt-3 font-display text-[22px] leading-snug text-ink" data-id="element-1311" data-mp="2gnt01qln3de5">{resource.title}</h2>
                <p className="mt-3 text-[15px] text-body" data-id="element-1312" data-mp="2uf7l02z3xonu">{resource.summary}</p>
                <Link to={`/resources/${resource.slug}`} className="mt-auto inline-flex items-center gap-2 pt-6 text-[15px] font-medium text-royal underline-offset-4 hover:underline" data-id="element-1313" data-mp="2phnwma8p3vi6">
                  Get the download
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1314" data-mp="36iijign9ixlw" />
                </Link>
              </Card>
            </Reveal>)}
        </div>
      </Section>
    </>;
}